"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * A controlled modal surface. Render it directly under TrainerApp for an
 * app-wide modal, or inside GameOverlay to constrain it to the game area.
 */
function Modal({ blocking = true, children, open, style, ...props }) {
    if (!open)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { ...props, role: "dialog", "aria-modal": "true", style: {
            alignItems: "center",
            backgroundColor: blocking ? "rgba(0, 0, 0, 0.6)" : "transparent",
            display: "flex",
            inset: 0,
            justifyContent: "center",
            pointerEvents: blocking ? "auto" : "none",
            position: "absolute",
            zIndex: 2000,
            userSelect: 'none',
            ...style,
        }, children: blocking ? children : (0, jsx_runtime_1.jsx)("div", { style: { pointerEvents: "auto" }, children: children }) }));
}
exports.Modal = Modal;
